var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('router-view'),_c('Loader',{attrs:{"active":_vm.loader,"size":50,"width":5}}),_c('Message'),_c('SliderDialog'),_c('ResponseDialog'),_c('DeleteDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }